import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CarouselModule, MediaModule, OutletModule } from '@spartacus/storefront';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ShimanoProductImagesComponent } from './shimano-product-images.component';

@NgModule({
  declarations: [ShimanoProductImagesComponent],
  imports: [CommonModule, RouterModule, MediaModule, OutletModule, SlickCarouselModule, CarouselModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        ProductImagesComponent: {
          component: ShimanoProductImagesComponent,
        },
      },
    }),
  ],
  exports: [ShimanoProductImagesComponent],
})
export class ShimanoProductImagesModule {}
